import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import ChatInterface from './ChatInterface';
import { useIndustry, INDUSTRIES } from '../lib/IndustryContext';
import styles from './HomeChatPage.module.css';

function switchIndustry(code) {
  const url = new URL(window.location.href);
  url.searchParams.set('industry', code);
  window.history.pushState({}, '', url.toString());
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export default function HomeChatPage() {
  const { industry } = useIndustry();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const newSessionTriggerRef = useRef(null);

  useEffect(() => {
    const onDocClick = (event) => {
      if (!menuRef.current?.contains(event.target)) setMenuOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const currentCode = industry || 'ev';
  const adminQuery = `industry=${currentCode}`;
  const currentIndustry = INDUSTRIES.find(i => i.code === currentCode) || INDUSTRIES[0];

  return (
    <main className={styles.page}>
      {/* 管理后台菜单（右上角固定） */}
      <div className={styles.adminMenu} ref={menuRef}>
        <button className={styles.adminNav} onClick={() => setMenuOpen(v => !v)} type="button">
          <span className={styles.adminIcon} aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M12 2L14.5 7.2L20 8L16 12L17 18L12 15.2L7 18L8 12L4 8L9.5 7.2L12 2Z" />
            </svg>
          </span>
          <span>管理后台</span>
          <span className={styles.caret}>{menuOpen ? '▴' : '▾'}</span>
        </button>
        {menuOpen && (
          <div className={styles.dropdown}>
            <Link to={`/admin?tab=knowledge&${adminQuery}`} className={styles.dropdownItem} onClick={() => setMenuOpen(false)}>知识库</Link>
            <Link to={`/admin?tab=conversations&${adminQuery}`} className={styles.dropdownItem} onClick={() => setMenuOpen(false)}>会话历史</Link>
            <Link to={`/admin?tab=customers&${adminQuery}`} className={styles.dropdownItem} onClick={() => setMenuOpen(false)}>客户记录</Link>
          </div>
        )}
      </div>

      <section className={styles.centerPanel}>
        <header className={styles.titleWrap}>
          <p className={styles.subtitle}>AI 智能体客服</p>
          <h1 className={styles.title}>{currentIndustry.title}</h1>
          <p className={styles.motto}>{currentIndustry.motto}</p>
          {/* 行业切换标签 + 新对话按钮 */}
          <div className={styles.industryBar}>
            <nav className={styles.industryTabs} aria-label="行业切换">
              {INDUSTRIES.map(ind => (
                <button
                  key={ind.code}
                  type="button"
                  className={
                    styles.industryTab +
                    (currentCode === ind.code ? ' ' + styles.industryTabActive : '')
                  }
                  onClick={() => switchIndustry(ind.code)}
                >
                  <span className={styles.industryTabDot} aria-hidden="true" />
                  {ind.label}
                </button>
              ))}
            </nav>
            <button
              type="button"
              className={styles.newSessionBtn}
              onClick={() => newSessionTriggerRef.current?.()}
              title="清空当前对话，开始新会话"
            >
              新对话
            </button>
          </div>
        </header>
        <div className={styles.chatWrap}>
          <ChatInterface hideHeader newSessionTriggerRef={newSessionTriggerRef} />
        </div>
      </section>
    </main>
  );
}
